export function inn(value: number) {
  const length = String(value).length

  if (length === 10 || length === 12) return true
  return false
}
